"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_final_form_1 = require("react-final-form");
const components_1 = require("components");
const utils_1 = require("utils");
/**
 * @name CalculatorSendPlansForm
 * @type Component
 * @param loading boolean
 * @param currentLocation LocationType
 * @param plansForPrinting PlansType
 * @param purchaseAmount number
 * @returns jsx
 */
function CalculatorSendPlansForm({ loading = false, currentLocation, onSubmit, plansForPrinting, purchaseAmount, }) {
    /*------------
     // State - local
    -------------*/
    const [sendMethod, setSendMethod] = (0, react_1.useState)('email');
    const [btnDisabled, setBtnDisabled] = (0, react_1.useState)(true);
    const [planInfo, setPlanInfo] = (0, react_1.useState)(null);
    const formSubmit = (values) => {
        const tmpObj = {
            ...planInfo,
            first_name: values.first_name,
            last_name: values.last_name,
            [values.sendMethodOption === 'sms' ? 'phone_number' : 'email']: values.sendMethod,
        };
        const submitObj = {
            ...tmpObj,
        };
        onSubmit({ ...submitObj });
    };
    const formValidate = (values) => {
        // Set Email/SMS Field
        if (values.sendMethodOption !== sendMethod) {
            setSendMethod(values.sendMethodOption);
        }
        // Disable if SMS confirm checkbox not checked
        if (values.sendMethodOption === 'sms') {
            if (values.sms_confirm && values.sms_confirm === true) {
                if (values.sendMethod &&
                    (0, utils_1.validatePhoneNumber)(values.sendMethod) === undefined) {
                    setBtnDisabled(false);
                }
                else {
                    setBtnDisabled(true);
                }
            }
            else {
                setBtnDisabled(true);
            }
        }
        // Disable if invalid email
        if (values.sendMethodOption === 'email') {
            if ((0, utils_1.validateEmail)(values.sendMethod) === undefined) {
                setBtnDisabled(false);
            }
            else {
                setBtnDisabled(true);
            }
        }
        return undefined;
    };
    /*------------
    // Effect(s)
   -------------*/
    // Init
    (0, react_1.useEffect)(() => {
        const planIds = plansForPrinting?.map((plan) => plan.id);
        const initVals = {
            plan_ids: planIds,
            purchase_amount: purchaseAmount,
            location_id: currentLocation?.locationId,
            practice_name: currentLocation?.name,
            down_payment: 0,
            insurance: 0,
            cash_discount_percentage: 0,
        };
        setPlanInfo({ ...initVals });
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "calculator-form", children: [(0, jsx_runtime_1.jsxs)("div", { className: "title", children: [(0, jsx_runtime_1.jsx)("h4", { children: "Send Payment Estimate" }), (0, jsx_runtime_1.jsx)("p", { children: "Select how you'd like to send the estimate to the Patient." })] }), (0, jsx_runtime_1.jsx)(react_final_form_1.Form, { initialValues: {
                    sendMethodOption: 'email',
                }, onSubmit: formSubmit, validate: formValidate, children: ({ handleSubmit, pristine, submitting }) => ((0, jsx_runtime_1.jsxs)("form", { onSubmit: handleSubmit, children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("fieldset", { className: "radioInput", children: [(0, jsx_runtime_1.jsx)("div", { className: "input-wrapper", children: (0, jsx_runtime_1.jsxs)("label", { children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "sendMethodOption", label: false, component: components_1.InputRadio, type: "radio", value: "email" }), ' ', "Email"] }) }), (0, jsx_runtime_1.jsx)("div", { className: "input-wrapper", children: (0, jsx_runtime_1.jsxs)("label", { children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "sendMethodOption", label: false, component: components_1.InputRadio, type: "radio", value: "sms" }), ' ', "Text"] }) })] }) }), (0, jsx_runtime_1.jsxs)("div", { className: "row", children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "first_name", component: components_1.InputText, placeholder: "First Name", label: "First Name", required: true, validate: utils_1.validateName }), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "last_name", component: components_1.InputText, placeholder: "Last Name", label: "Last Name", required: true, validate: utils_1.validateName }), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "sendMethod", mask: sendMethod === 'email' ? '' : '(000) 000-0000', component: components_1.InputMask, label: sendMethod === 'email' ? 'Email' : 'Mobile Phone Number', placeholder: sendMethod === 'email' ? 'Email' : 'Mobile Phone Number', required: true, validate: sendMethod === 'email' ? utils_1.validateEmail : utils_1.validatePhoneNumber }), sendMethod === 'sms' ? ((0, jsx_runtime_1.jsx)("div", { className: "input-wrapper", children: (0, jsx_runtime_1.jsxs)("label", { className: "label-checkbox", children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "sms_confirm", type: "checkbox", component: components_1.InputCheckbox, required: true }), ' ', "Please confirm that the Patient is willing to receive SMS messages."] }) })) : null] }), (0, jsx_runtime_1.jsx)("div", { className: "align-center", children: (0, jsx_runtime_1.jsx)(components_1.Button, { type: "submit", className: `button-primary button-warn-outline ${btnDisabled ? 'is-disabled' : 'is-enabled'}`, "aria-disabled": btnDisabled && !(pristine || submitting), children: loading ? '...Submitting' : 'Submit' }) })] })) })] }));
}
exports.default = CalculatorSendPlansForm;
